import React, {useEffect, useState} from 'react';

import * as lineActions from '../../../_redux/orderlines/orderlinesActions';
import * as orderActions from '../../../_redux/orders/ordersActions';
import {useSubheader} from "../../../../../../_metronic/layout";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
    ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import {OrdersListTable} from "../orders-list-table/OrdersListTable";
import {OrderLinesTable} from "./order-lines-table/OrderLinesTable";
import {RecordLogs} from "../../../../../../_metronic/_partials/widgets/logs/RecordLogs";
import {HasWriteAccess, IsPortalUser} from "../../../../../../_metronic/_helpers/AccessControlHelpers";
import {ORDER_MODEL} from "../../../../../../_metronic/_helpers/AppModels";

export function OrdersListSingle({
                                     history,
                                     match: {
                                         params: {id}
                                     }
                                 }) {
    const subHeader = useSubheader();

    const [title, setTitle] = useState("");

    const dispatch = useDispatch();

    const {actionsLoading, selectedOrder} = useSelector(
        (state) => ({
            actionsLoading: state.orders.actionsLoading,
            selectedOrder: state.orders.selectedOrder
        }),
        shallowEqual
    );

    const {user} = useSelector((state) => state.auth);


    useEffect(() => {
        dispatch(orderActions.fetchOrder(id));
    }, [id, dispatch]);

    useEffect(() => {
        let _title = "";

        if (selectedOrder) {
            _title = selectedOrder.name;
        }

        setTitle(_title);

        subHeader.setTitle(_title);

    }, [selectedOrder]);

    const backToOrdersList = () => {
        history.push("/reports/sales");
    }
    
    const onApproveClick = () => {
        dispatch(orderActions.approveOrder(selectedOrder.id))
            .then(() => {
                dispatch(orderActions.fetchOrder(id));
            })
    }

    return (
        <>
            <Card>
                {actionsLoading && <ModalProgressBar/>}
                <CardHeader title={title}>
                    <CardHeaderToolbar>
                        <button
                            type={"button"}
                            onClick={backToOrdersList}
                            className={"btn btn-light"}
                        >
                            <i className={"fa fa-arrow-left"}/>
                            برگشت
                        </button>

                        {IsPortalUser(user) && HasWriteAccess(user, ORDER_MODEL) && !selectedOrder?.approved && selectedOrder?.orderStatus !== 0 && (
                            <button type="button"
                                    className={'btn btn-primary'}
                                    onClick={onApproveClick}
                                    >
                                تایید تحویل سفارش
                            </button>
                        )}
                    </CardHeaderToolbar>
                </CardHeader>

                <CardBody>
                    <OrderLinesTable/>
                </CardBody>
            </Card>
            
            <Card>
                <CardHeader title={"سابقه"}/>
                <CardBody>
                    <RecordLogs recordId={id} recordModel={"Order"}/>
                    
                </CardBody>
            </Card>
        </>
    )

}